module.exports = __webpack_public_path__ + "img/yritysluotto@2x.aa8bc6d.png";